import { Plus } from 'lucide-react';
import { Link } from 'react-router';
import { useDestinations } from '@/api/hooks';
import { Badge, Checkbox, Skeleton } from '@/components/ui';
import { DESTINATION_ICON } from './icons';

/** Checkbox list of the user's destinations. Unverified ones can't be picked yet. */
export function DestinationPicker({
  value,
  onChange,
  error,
  legend = 'Send to',
}: {
  value: string[];
  onChange: (ids: string[]) => void;
  error?: string;
  legend?: string;
}) {
  const destinations = useDestinations();
  return (
    <fieldset aria-describedby={error ? 'destinations-error' : undefined}>
      <legend className="text-sm font-medium text-ink">{legend}</legend>
      {destinations.isPending && <Skeleton className="mt-2 h-20" />}
      <div className="mt-3 flex flex-col gap-3">
        {destinations.data?.map((d) => {
          const Icon = DESTINATION_ICON[d.type];
          return (
            <div key={d.id} className="flex items-center gap-2">
              <Checkbox
                className="flex-1"
                label={
                  <span className="inline-flex items-center gap-2">
                    <Icon className="size-4 text-muted-ink" aria-hidden />
                    {d.label}
                  </span>
                }
                description={d.verified ? undefined : 'Verify it on the Destinations page first.'}
                disabled={!d.verified}
                checked={value.includes(d.id)}
                onChange={(e) => onChange(e.target.checked ? [...value, d.id] : value.filter((x) => x !== d.id))}
              />
              {!d.verified && <Badge>Not verified</Badge>}
            </div>
          );
        })}
      </div>
      <Link to="/destinations" className="mt-3 inline-flex items-center gap-1 text-sm text-muted-ink underline-offset-4 hover:text-ink hover:underline">
        <Plus className="size-4" aria-hidden /> Add a destination
      </Link>
      {error && (
        <p id="destinations-error" className="mt-2 text-xs font-medium text-down">
          {error}
        </p>
      )}
    </fieldset>
  );
}
